export default __webpack_public_path__ + "static/media/ic_bnb_24.dad97db5.svg";